module.exports = __webpack_public_path__ + "static/media/info_report.bdf71d82.svg";